import React from "react";
import config from "../../../config";
import { ApiHandlerPureComponent } from "./ApiHandlerPureComponent";
import { Content } from "../../../pages/Help";

interface Props {
  onAuthError?: () => void;
}

export default class UTP2HelpAPIs extends React.PureComponent<Props> {
  private apiResponseHandler = new ApiHandlerPureComponent({
    onAuthError: this.props.onAuthError,
  });

  private static readonly BASE_URL: string = `${config.apiGateway.UTP2_API}/api/Help`;

  async getMarkdown(language: string): Promise<Content> {
    const apiAddress = `${UTP2HelpAPIs.BASE_URL}/language/${language}`;
    return await this.apiResponseHandler.getWithoutAuthorization(apiAddress);
  }
}
